import { Component, Input } from '@angular/core';

@Component({
  selector: 'bfd-icon',
  templateUrl: './bfd-icon.component.html',
  styleUrls: ['./bfd-icon.component.scss']
})
export class IconComponent  {
  @Input() typeIcon: string = 'icon';
  @Input() img: string = 'wallet';
  @Input() typeColor: string = '';
  @Input() size: string = 'medium';

  public getSize(): string {
    switch (this.size) {
      case 'small':
        return this.typeIcon === 'icon' ? 'size-small-icon' : 'size-small-pictograma';
      case 'medium':
        return this.typeIcon === 'icon' ? 'size-medium-icon' : 'size-medium-pictograma';
      case 'large':
        return this.typeIcon === 'icon' ? 'size-large-icon' : 'size-large-pictograma';
      case 'ultra':
        return this.typeIcon === 'icon' ? 'size-ultra-icon' : 'size-ultra-pictograma';
      default:
      return this.typeIcon === 'icon' ? 'size-large-icon' : 'size-large-pictograma';
    }
  }

  public getColor(): string {
    switch (this.typeColor) {
      case 'danger':
        return 'c-danger';
      case 'primary':
        return 'c-positive';
      case 'alert':
        return 'c-alert';
      case 'dark':
        return 'c-dark';
      case 'info':
        return 'c-info';
      default:
      return '';
    }
  }
}
